// extracted by mini-css-extract-plugin
module.exports = {"contentPlaceholder":"content-placeholder-module--content-placeholder--1r2Gh"};